import React, { useState } from "react";


import { Col, Row, Label , Alert} from "reactstrap";

import Select from "react-select";



//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";





import './style/casosAdd.scss'

import PrecontactoAddModal from "../../../Precontacto/PrecontactoAddModal";
import { useSelector } from "react-redux";


const PreContactoForm = (props) => {

  const [crearModal, setCrearModal] = useState(false);

  const handleCasoClick = (selected) => {
    setCrearModal(true);
  };

  const handleCloseModal = () => {
    setCrearModal(false);
  };
 

  const error = useSelector(state=>state.Casos.error)



  return (
    <React.Fragment>
      
      { crearModal? (
        <PrecontactoAddModal 
        style={{ overflow: 'auto' , zIndex:'100'}}
        crearModal={crearModal}
        onCloseClick={handleCloseModal}
       
     
 
        >
      </PrecontactoAddModal>
        ):null} 

      
      <Row className="col-lg-12 justify-content-center ">
        <Col lg={6} className="mb-3">
          {/* SElect Precontacto */}

          <Label for="pre_contacto" className="col-form-label col-sm-6 d-flex">
            <strong>PRE-CONTACTO</strong>
            <span
              className="bx bx-user-plus fa-lg align-middle btn-add"
              onClick={() => handleCasoClick()}
            ></span>
          </Label>

          <Select
            id="pre_contacto"
            name="pre_contacto"
            placeholder="Seleccione"
            onChange={props.handleSelectPreContacto}
            options={
              Array.isArray(props.leads)
                ? props.leads.map((item) => ({
                    label:
                      item.first_name === ""
                        ? item.razon_social
                        : item.first_name,
                    value: item.id,
                  }))
                : []
            }
          />
        </Col>

        <Col md={6} className="mb-3">
          <Label for="tipo_visita" className="form-label mt-2">
          <strong> TIPO DE VISITA </strong>
          </Label>
          <Select
            id="tipo_visita"
            name="tipo_visita"
            options={props.TipoVisita}
            onChange={props.handleSelectTipoVisita}

            autoFocus
          />
          
{error && error.tipo_visita ? (
                              <Alert color = 'danger' className="mt-2">{error.tipo_visita}</Alert>
                              ):null} 
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default PreContactoForm

